import axios from 'axios';
import { localVariables } from '../utils/constants';

const apiClient = axios.create({
    baseURL: process.env.REACT_APP_HOST_IP
});

// Request interceptor
apiClient.interceptors.request.use(config => {
    const token = localStorage.getItem(localVariables.ACCESSTOKEN);
    const lang = localStorage.getItem(localVariables.LANGUAGE);
    
    config.headers = {
        ...config.headers,
        'Content-Type': 'application/json',
        'Authorization': token ? `Bearer ${token}` : '',
        'ngrok-skip-browser-warning': 'true',
        'x-language': lang ? lang : 'en'
    };
    
    return config;
});

// Response interceptor
apiClient.interceptors.response.use(
    // Success handler
    response => response,
    error => {
        return Promise.reject(error);
    }
);

export default apiClient;